import { render, staticRenderFns } from "./_matrix.table.vue?vue&type=template&id=29cd1e18&scoped=true"
import script from "./_matrix.table.vue?vue&type=script&lang=js"
export * from "./_matrix.table.vue?vue&type=script&lang=js"
import style0 from "./_matrix.table.vue?vue&type=style&index=0&id=29cd1e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cd1e18",
  null
  
)

export default component.exports